import React, { useState, useEffect } from "react";
import { icons, FLAVOR } from "../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../services/FetchService";
import toast from "react-hot-toast";
import { staticSort } from "../helpers/helperFunctions";
import DeleteGeofenceModal from "../components/Modals/DeleteGeofenceModal";
import GeofenceRowNew from "../components/Geofences/GeofenceRowNew";
import { AnimatePresence, motion } from "framer-motion";
import { useIsMobile } from "../helpers/customHooks";
import { useSidebarContext } from "../components/Sidebar/SiderbarContext";
import NewButton from "../components/Buttons/NewButton";
import DeviceSelectionRowNew from "../components/Devices/DeviceSelectionRowNew";
import SegmentedControl from "../components/SegmentedControl/SegmentedControl";
import SegmentedControlNew from "../components/SegmentedControl/SegmentedControlNew";
import GeofenceMap from "../components/Map/GeofenceMap/GeofenceMap";
import { useGeofenceContext } from "../components/Map/GeofenceMap/GeofenceContext";

const GeofenceNew = () => {
	const MOBILE = useIsMobile();
	const { t } = useTranslation();
	const [showActions, setShowActions] = useState(false)
	const [deleteToggle, setDeleteToggle] = useState(false)
	const [deleteAllGeo, setDeleteAllGeo] = useState(false)
	const [showAddDevice, setShowAddDevice] = useState(false);
	const [geofenceList, setGeofenceList] = useState([])
	const [geofenceListFull, setGeofenceListFull] = useState([])
	const [createGeofence, setCreateGeofence] = useState(false)
	const [errorText, setErrorText] = useState("")
	const [geoName, setGeoName] = useState("")
	const [chooseAll, setChooseAll] = useState(false)
	const [deviceList, setDeviceList] = useState([])
	const [deviceListFull, setDeviceListFull] = useState([])
	const [checkedDevices, setCheckedDevices] = useState([])
	const [currentFence, setCurrentFence] = useState()
	const [allSelected, setAllSelected] = useState(false)
	const [loading, setLoading] = useState(true)
	// const { creatingGeo, setCreatingGeo, setContextGeoMethod, contextGeoMethod, geoData, setGeoData, setContextSaveGeofence, setInitialGeoData, setGeofenceDeleted, setGeofenceCreated } = useMapToggles();
	const [toggleDrag, setToggleDrag] = useState(false)
	const [temporaryFence, setTemporaryFence] = useState([])
	const { setActionbarContent, setTopbarContent } = useSidebarContext();
	const {
		initialData,
		setInitialData,
		fenceData,
		setFenceData,
		creating,
		setCreating,
		method,
		setMethod,
		saveFence,
		setSaveFence,
		setGeofenceDeleted
	} = useGeofenceContext();

	
	const [modals, setModals] = useState({
		delete_geofence: false	
	})

	useEffect(() => {
		getGeofences()
		//getDevices()

		return () => {
			setActionbarContent(null)
			setTopbarContent(null)
		}
	}, []);

	const getGeofences = () => {
		request.get("geofence/info").then((response) => {
			if(response.data && response.status === 200){
				let sorted = staticSort(response.data.response, "name");
				setGeofenceList(sorted)
				setGeofenceListFull(sorted)
				setLoading(false)
			}
			
		});	
	}

	const getDevices = () => {
		const obj = {
			type: "check_permission_device_geofence"
		}
		request.post("", "devices/info/extended", obj).then((response) => {
			let sorted = staticSort(response?.data.devices, "name")
			setDeviceListFull(sorted)
		})
	};
	useEffect(() => {
		let sorted = staticSort(deviceListFull, "name")
		setDeviceList(sorted)
		
	}, [deviceListFull])

	const handleChange = (field, e) => {
        setErrorText("")
        if (field === "name"){
            setGeoName(e.target.value);
		};
    }
	// useEffect(() => {
	// 	setCreatingGeo(createGeofence)
	// 	if(!createGeofence){
	// 		closeActions()
	// 	}
	// }, [createGeofence])

	// const closeActions = () => {
	// 	setCreateGeofence(false)
	// 	setCheckedDevices([])
	// 	setContextGeoMethod("poly")
	// 	setCreatingGeo(false)
	// 	setCurrentFence(null)
	// 	setGeoName("")
	// 	setInitialGeoData(null)
	// 	setShowActions(false)
	// 	setDeleteToggle(false)
	// 	setTemporaryFence([])
	// 	let updatedGeo = [...geofenceList];
	// 	updatedGeo.map((fence, index) => {
	// 		fence.selected = false
	// 	})
	// 	let updatedDevices = [...deviceListFull];
	// 	updatedDevices.map((device, index) => {
	// 		device.selected = false
	// 	})
	// 	setGeofenceList(updatedGeo)
	// }


	const closeActionsNew = () => {
		setTemporaryFence([]);
		setMethod("circle")
		setCreating(false)
		setCreateGeofence(false)
		setFenceData(null)
		setSaveFence(false)
		setCurrentFence(null)
		getDevices()
		setInitialData(null)
		setGeoName("")
	}

	const toggleModal = (modalName) => {
		setModals((prevState) => ({
			...prevState,
			[modalName]: !prevState[modalName],
		}));
	};

	// useEffect(() => {
	// 	if(geoData){
	// 		let data = {}
	// 		if(currentFence){
	// 			let geoPos = geoData;
	// 			if(!geoPos.center){
	// 				geoPos = geoData.map(location => ([
	// 					location.lat,
	// 					location.lng
	// 				]));
	// 			}
	// 			data = {
	// 				geofenceid: currentFence.id,

	// 				name: geoName,
	// 				deviceid: checkCheckedDevices(),
	// 				type: contextGeoMethod === "poly" ? "POLYGON" : "CIRCLE",
	// 				...(contextGeoMethod === "poly" 
	// 					? { points: geoPos }
	// 					: {
	// 						latitude: geoPos.center.lat,
	// 						longitude: geoPos.center.lng,
	// 						radius: geoPos.radius
	// 					} 
	// 				)
	// 			}
	// 			request.post("", "geofence/update", data).then((response) => {
	// 				if(response.data.successful){
	// 					closeActions()
	// 					setGeofenceCreated(true)
	// 					getGeofences()
	// 					setGeoData()
	// 					getDevices()
	// 					toast.success(t("toast.done"))
	// 				}else{
	// 					toast.error(t("toast.error"))
	// 				}
	// 			})
	// 		}else{
	// 			let geoPos = geoData;
	// 			if(!geoPos.center){
	// 				geoPos = geoData.map(location => ([
	// 					location.lat,
	// 					location.lng
	// 				]));
	// 			}
	// 			data = {
	// 				name: geoName,
	// 				deviceid: checkCheckedDevices(),
	// 				type: contextGeoMethod === "poly" ? "POLYGON" : "CIRCLE",
	// 				...(contextGeoMethod === "poly" 
	// 					? { points: geoPos }
	// 					: {
	// 						latitude: geoPos.center.lat,
	// 						longitude: geoPos.center.lng,
	// 						radius: geoPos.radius
	// 					} 
	// 				)
	// 			}
	// 			request.post("", "geofence/create", data).then((response) => {
	// 				if(response.data.successful){
	// 					closeActions()
	// 					setGeofenceCreated(true)
	// 					getGeofences()
	// 					setGeoData()
	// 					getDevices()
	// 					toast.success(t("toast.done"))
	// 				}else{
	// 					toast.error(t("toast.error"))
	// 				}
	// 			})
	// 		}
	// 	}
	// 	closeActions()
	// 	setContextSaveGeofence(false)
	// }, [geoData])

	const editGeofence = (fence) => {
		setCreateGeofence(!createGeofence)
		setCurrentFence(fence)
		//setDeviceListFull(OGDeviceList)
	}

	useEffect(() => {
		if(!currentFence){
			deviceListFull.map((device, index) => {
				device.selected = false
            })
			return
		}
		setGeoName(currentFence?.name)
		deviceListFull.map((device, index) => {
			if (currentFence.deviceid.includes(device.id)) {
				selectDevice(index)
			}
		});
		if(currentFence?.type === "POLYGON"){
			setMethod("poly")
			setInitialData(currentFence?.points)
		}else{
			setMethod("circle")
			const data = { radius: currentFence?.radius, center: { lat: currentFence?.latitude, lng: currentFence?.longitude } }
			setInitialData(data)
		}
	}, [currentFence])

	useEffect(() => {
		if(deleteAllGeo){
			let updatedGeo = [...geofenceList];
            updatedGeo.map((fence, index) => {
				fence.selected = true
            })
			setGeofenceList(updatedGeo)
		}else{
			let updatedGeo = [...geofenceList];
            updatedGeo.map((fence, index) => {
				fence.selected = false
            })
			setGeofenceList(updatedGeo)
		}
    }, [deleteAllGeo])


	const selectGeofence = (index) => {
        let updatedGeo = [...geofenceList];
        if (index !== -1) {
            var fence = updatedGeo[index];
            if (fence.selected !== true){
                fence.selected = true;
            }else{
                fence.selected = false;
            } 
            updatedGeo[index] = fence;
            setGeofenceList(updatedGeo);
          }
    }

	// const renderCard = () => {
	// 	return (
	// 	<Card className={`py-0 px-1 mt-1 mb-2`}>
    //         <div className="d-flex flex-row justify-content-between align-items-center px-1 pt-3 pb-2 border-bottom">
    //             <h4 className="mb-2">{t("events.actions")}</h4>
    //             <img
    //                 className="mb-2 size_25 cursor-pointer close_img"
    //                 src={icons.close_gray}
    //                 onClick={() =>setShowActions(!showActions)}
    //                 alt="..."
    //             />
    //         </div>
	// 		<ul className="list-group list-group-flush">
	// 			<li
	// 				className="cursor-pointer list-group-item d-flex justify-content-between align-items-center"
	// 				onClick={() => {setDeleteToggle(!deleteToggle)}}
	// 			>
	// 			<p className={`my-2 ${deleteToggle ? "primary" : "dark_grey"}`}>
	// 				{t("geofence.delete_geofence")}
	// 			</p>
	// 			</li>
	// 		</ul>
    //     </Card>
	// 	)
	// }

	// const filterSearch = (searchWord) => {
	// 	let array;
	// 	let match;

	// 	if(createGeofence){
	// 		array = deviceListFull
	// 		if((!searchWord || searchWord === "") && deviceListFull.length>0){
	// 			setDeviceList(deviceListFull)
	// 			return
	// 		}
	// 		match = array.filter((device) => {
	// 		const item = searchWord.toLowerCase();
	// 		return (
	// 			device?.name?.toLowerCase().indexOf(item) > -1 ||
	// 			device?.uniqueid?.toLowerCase().indexOf(item) > -1
	// 			);
	// 		})
	// 		setDeviceList(match)
	// 	}else{
	// 		array = geofenceListFull
	// 		if(!searchWord || searchWord === ""){
	// 			setGeofenceList(geofenceListFull)
	// 			return
	// 		}
	
	// 		match = array.filter((fence) => {
	// 		const item = searchWord.toLowerCase();
	// 		return (
	// 			fence.name.toLowerCase().indexOf(item) > -1
	// 			);
	// 		})
	// 		setGeofenceList(match)
	// 	}
	// }

	const checkCheckedDevices = () => {
		let checkedDevices = deviceListFull.filter(device => device.selected).map(device => device.id);
		return checkedDevices
	}


	// const checkCheckedFences = () => {
	// 	let checked = geofenceList?.filter(fence => fence.selected).map(fence => parseInt(fence.id));
	// 	return checked
	// }

	const returnSelectedFences = () => {
		let selected = geofenceList?.filter(fence => fence.selected)
		return selected
	}

	const deleteGeofence = (ids) => {
		const id = currentFence?.id
			
			request.post("", "geofence/delete", {geofenceid: id}).then((response) => {
				if(response.data.successful){
				//	setGeofenceDeleted(true)
					getGeofences()
				//	closeActions()
				//	setInitialGeoData(null)
					toggleModal("delete_geofence")
					closeActionsNew()
					setGeofenceDeleted(true)
					setCurrentFence(null)
					setGeoName("")
					toast.success(t("toast.done"))
				}else{
					const msg = response?.data?.message
                	toast.error(msg ?? t("toast.error"))
				}})
		// ids.map((fence) => {
		// 	request.post("", "geofence/delete", {geofenceid: fence}).then((response) => {
		// 		if(response.data.successful){
		// 		//	setGeofenceDeleted(true)
		// 			getGeofences()
		// 		//	closeActions()
		// 		//	setInitialGeoData(null)
		// 			toggleModal("delete_geofence")
		// 			getDevices()
		// 			toast.success(t("toast.done"))
		// 		}else{
		// 			toast.error(t("toast.error"))
		// 		}
		// 	})
		// })
	}

	useEffect(() => {
		if(createGeofence){
			setToggleDrag(true)
		}else{
			setToggleDrag(false)

		}
	}, [createGeofence])

	const selectDevice = (index, addOrRemove = 0) => {
		setDeviceListFull(prevDevices => {
			return prevDevices.map((device, i) => {
				if (i === index) {
					const isSelected = !device.selected;
	
					// Update temporaryFence correctly
					setTemporaryFence(prevFence =>
						isSelected
							? [...prevFence, device.id] // Add device ID
							: prevFence.filter(id => id !== device.id) // Remove device ID
					);
	
					return {
						...device,
						selected: isSelected,
						geofence_permissions: {
							...device.geofence_permissions,
							geofence_count: device.geofence_permissions.geofence_count + addOrRemove
						}
					};
				}
				return device;
			});
		});
	};

	// useEffect(() => {
	// 	setDeviceListFull(prevDevices => {
	// 		const updatedDevices = prevDevices.map(device => {
	// 			const canSelect = device?.geofence_permissions?.geofence_count < device?.geofence_permissions?.geofencelimit;
	// 			const wasSelected = device.selected;
	
	// 			return {
	// 				...device,
	// 				selected: allSelected ? (wasSelected || canSelect) : false, // Keep already selected devices
	// 				geofence_permissions: {
	// 					...device.geofence_permissions,
	// 					geofence_count: allSelected
	// 						? (wasSelected ? device.geofence_permissions.geofence_count : canSelect ? device.geofence_permissions.geofence_count + 1 : device.geofence_permissions.geofence_count) // Only increase if selectable
	// 						: (wasSelected ? device.geofence_permissions.geofence_count - 1 : device.geofence_permissions.geofence_count) // Only decrease if previously selected
	// 				}
	// 			};
	// 		});
	
	// 		// Ensure we update `temporaryFence` only after getting the correct selection state
	// 		setTemporaryFence(updatedDevices.filter(device => device.selected).map(device => device.id));
	
	// 		return updatedDevices;
	// 	});
	// }, [allSelected]);

	const geofenceListContent = () => {
		return(
			<>
				<div className={`${deleteToggle ? "pushed" : ""} rounded24 margin-x-20 mt-3 margin-bottom-20 overflow-hidden`}>
					{geofenceList?.map((fence, index) => (
						<GeofenceRowNew geofence={fence} geofenceLength={geofenceList.length} index={index} key={index} checkboxVisibility={deleteToggle} setGeofenceToggle={() => selectGeofence(index)} checkedFences={[]} editGeofence={(data) => editGeofence(data)}/>
					))}
					{(!geofenceList || geofenceList?.length === 0) && !loading &&
						<h3 className="bold dark-grey text-center mt-5">{t("geofence.no_geofences")}</h3>
					}
				</div>
			</>
		)
	}

		const segments = [
            {
                label: t("geofence.circle"),
                value: "circle"
            },
            {
                label: t("geofence.draw"),
                value: "poly"
            }
        ]

	const createGeofenceContent = () => {
		return(
			<>
				<div className="d-flex flex-column mt-3">
					<div className="body bold">{t("geofence.geofence_name")}</div>
					<input 
						type="text"
						className="form-control bg-white rounded24 p-3 grey-blue"
						id="name"
						placeholder={t("geofence.name")}
						value={geoName}
						onChange={(e) => {
							handleChange("name", e);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
							e.preventDefault();// Prevent the default Enter key behavior
							
							}
						}}
					/>
					<div className="body bold mt-2">{t("geofence.select_devices")}</div>
					{deviceList.length > 0 
						?
						// <div className={`${!MOBILE ? "geofence_device_list" : ""} scrollable-y rounded24 bg-white`} style={{height: MOBILE ? "400px" : ""}}>
							<div className={`geofence_device_list scrollable-y rounded24 bg-white`}>

							{/* <DeviceSelectionRow 
								text={t("devices.choose_all")}
								index={-1}
								selected={deviceListFull.some(device => !device.selected) ? false : true}
								onClick={() => setAllSelected(!allSelected)}
							/> */}
							{deviceList.map((device, index) => {
								const limit = device?.geofence_permissions?.geofencelimit ?? 0
								const count = device?.geofence_permissions?.geofence_count ?? 0
								const editable = (currentFence?.deviceid.includes(device.id) || temporaryFence?.includes(device.id)) ?? false

								const limitToast = () => toast(device?.geofence_permissions?.info_message, {icon: <img  className="size_20 grey-blue-icon" src={icons.info_icon} alt=""/>, autoClose: 10000})
								return(
									<DeviceSelectionRowNew
										key={index}
										index={index}
										text={device.name}
										last={index === deviceList?.length - 1}
										selected={device.selected ? true : false}
										subtitle={t("devices.geofences_used", {val1: count , val2: limit})}
										selectable={editable ? true : count >= limit ? false : true}
										onClick={() => (count < limit) || editable ? selectDevice(index, device.selected ? -1 : 1) : limitToast() }
									/>
								)
							})}
						</div>
						:
						<h3 className="bold dark-grey text-center mt-5">{t("geofence.no_devices")}</h3>
					}
					<div className="body bold mt-2">{t("geofence.place_geofence")}</div>
						<SegmentedControl
							name="geofence"
							callback={(val) => togglePlacement(val)}
							value={method}
							segments={segments}
							segmentWidth="w-100"
							className="bg-white"
						/>
					{MOBILE &&
					<div className="mt-2 rounded24 bg-white p-2" style={{height: "400px"}}>
						<GeofenceMap geofences={geofenceList} />
					</div>
					}
					<NewButton className={`rounded15 bg-gradient text-white new-input mt-3 bold ${checkCheckedDevices().length === 0 ? "disabled" : ""}`} onClick={() => setSaveFence(true)}>{t("geofence.save")}</NewButton>
					{currentFence &&
						<NewButton className="rounded15 bg-red text-white new-input mt-3 bold" onClick={() => toggleModal("delete_geofence")}>{t("geofence.delete")}</NewButton>
					}
				</div>
			</>
		)
	}

	const listVariants = {
		base: { 
			x: "0", 
			opacity: 1, 
			pointerEvents: "auto",
		},
		pushed: { 
			x: "-120%", 
			opacity: 1, 
			pointerEvents: "none",
			position: "absolute",
		},
	};

	useEffect(() => {
		if(createGeofence){
			const topcontent = {
				left: (
					<NewButton notext={true} className="full-rounded menu-button bg-white" icon={icons.chevron_left} iconClass={"size_15 primary-icon"} onClick={() => setCreateGeofence(!createGeofence)} />
				),
				center: (
					<h4 className="mega-center">{currentFence ? t("geofence.edit_geofence") : t("geofence.new_geofence")}</h4>
				)
			}
			setTopbarContent(topcontent)
		}else{
			const topcontent = {
				left: (
					"burger"
				),
				center: (
					<h4 className="mega-center">{t("geofence.geofences")}</h4>
				),
				right: (
					<NewButton notext={true} className="full-rounded menu-button bg-white" icon={icons.plus} iconClass={"size_20 primary-icon"} onClick={() => setCreateGeofence(!createGeofence)} />
				)
			}
			setTopbarContent(topcontent)
			closeActionsNew()
		}
		setCreating(createGeofence)
	}, [createGeofence])

	const togglePlacement = (val) => {
		setMethod(val)
	}

	const saveGeofence = async() => {
		try{
			const object = {
				...(currentFence && { geofenceid: currentFence.id }),
				name: geoName,
				deviceid: checkCheckedDevices(),
				type: method === "poly" ? "POLYGON" : "CIRCLE",
					...(method === "poly")
					? { 
							points: fenceData.map(location => ([
								location.lat,
								location.lng
						]))
					}
					: { 
						latitude: fenceData?.center?.lat,
						longitude: fenceData?.center?.lng,
						radius: fenceData.radius
					}
			}
			const url = currentFence ? "geofence/update" : "geofence/create"
			const response = await request.post("", url, object);
			if(response.data.successful){
				toast.success(t("toast.done"))
				setTimeout(() => {
					getGeofences()
					getDevices()	
				}, 250);
				closeActionsNew()
			}else{
				const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
				setSaveFence(false)
				setFenceData(null)
			}
			
		}catch{

		}finally{

		}
	}

	useEffect(() => {
		if(!fenceData) return;
		saveGeofence()
	}, [fenceData])

	return (
		<>
			<div className="info-section scrollable-y" id="resizable-element">
				<AnimatePresence mode="sync">
				<motion.div
					className={`${createGeofence ? "" : ""}`}
					key="list"
					variants={listVariants}
					initial={"base"}
					animate={createGeofence ? "pushed" : "base"}  // 👈 wait for ready
					transition={{ duration: 0.25, ease: "easeOut" }}
				>
					{geofenceListContent()}
				</motion.div>
				<motion.div
					key={`create`}
					initial={{ x: "100%", opacity: 0 }}
					className={`margin-x-20 padding-bottom-20 ${!createGeofence ? "d-none": ""}`}
					animate={createGeofence ? { x: 0, opacity: 1 } : { x: "100%", opacity: 1}} // 👈 don’t enter until ready
					exit={{ x: "100%", opacity: 0 }}
					transition={{ duration: 0.25, ease: "easeOut" }}
					style={{ zIndex: 5 }}
				>
					{createGeofenceContent()}
				</motion.div>

				</AnimatePresence>
			</div>
			<DeleteGeofenceModal show={modals.delete_geofence} fences={/*returnSelectedFences()*/[currentFence]} deleteFences={(ids) => deleteGeofence(ids)} onClose={() => toggleModal("delete_geofence")} />

		</>
	);
};

export default GeofenceNew;
